import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const title = 'text - Provided Fields';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "text"
    }}>{`Text`}</h1>
    <p>{`The simplest text input`}</p>
    <h2 {...{
      "id": "schema"
    }}>{`Schema`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`<fieldName in value>:
  type: text
  label: string? # fieldName to display
  defaultVal: string? # default value
  helperText: string? # text to help user to input
  placeholder: string? # placeholder text
  disabled: boolean? # disable the input, default false
`}</code></pre>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: text
    label: my field
    helperText: help
    defaultVal: default value
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "use-your-own"
    }}>{`Use Your own`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { FieldComponent, FieldPropTypes, ReformlProvider, BaseForm } from 'reforml'
import React, { FunctionComponent, useState } from 'react'
import PropTypes from 'prop-types'

const MyText: FieldComponent<string> = ({
  helperText,
  onChange,
  value,
  label,
  defaultVal,
  ...props
}) => {
  return (
    <div>
      <div>{label}: <input {...props} onChange={onChange} value={value}/></div>
      <div>{helperText}</div>
    </div>
  )
}

MyText.propTypes = {
  ...FieldPropTypes,
  value: PropTypes.string
}

const TextPage: FunctionComponent = () => {
  const [value, setValue] = useState({})
  return (
    <ReformlProvider fieldComponents={{ text: MyText }}>
      <BaseForm fields={{ myField: { type: 'text', label: 'label', helperText: 'helper' } }} onChange={setValue} value={value}/>
    </ReformlProvider>
  )
}

export default TextPage
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      